import React from 'react';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Quieres orar, pero no sabes qué decir', 'Empiezas con intención… pero te distraes o lo dejas', 'Sientes que te falta constancia en tu vida espiritual', 'En momentos difíciles, no encuentras las palabras', 'Sabes que necesitas acercarte a Dios, pero no sabes cómo empezar'];
  return <section className="py-20 px-6 bg-cream" data-id="element-107">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-108">
        <div className="w-full md:w-1/2" data-id="element-109">
          <div className="relative" data-id="element-110">
            <div className="absolute inset-0 bg-warm-orange/10 rounded-3xl transform -rotate-3 scale-105" data-id="element-111"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vaZ8WyQ633MSy4cPYCQtDA/Hyper-realistic_candid_photography._202604112126.png" alt="Persona reflexionando en un momento de oración" className="relative w-full h-auto rounded-3xl shadow-xl object-cover" data-id="element-112" />
          </div>
        </div>

        <div className="w-full md:w-1/2" data-id="element-113">
          <h2 className="font-fredoka text-3xl md:text-4xl text-charcoal mb-8" data-id="element-114">
            ¿Te ha pasado esto al intentar orar?
          </h2>

          <ul className="space-y-4 mb-8" data-id="element-115">
            {problems.map((problem, index) => <li key={index} className="flex items-start gap-3" data-id="element-116">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-117" />
                <span className="text-lg text-charcoal font-medium" data-id="element-118">
                  {problem}
                </span>
              </li>)}
          </ul>

          <div className="bg-white p-6 rounded-2xl shadow-sm border-l-4 border-sage-green" data-id="element-119">
            <p className="text-lg italic text-gray-700 font-medium" data-id="element-120">
              "No es falta de fe… es que nadie te enseñó una forma simple de hablar con Dios todos los días."
            </p>
          </div>
        </div>
      </div>
    </section>;
}